define('SC.GlobalConfiguration.1.0.0.GlobalConfiguration', [
    'jQuery'
], function GlobalConfiguration(
    jQuery // eslint-disable-line no-unused-vars
) {
    'use strict';

    return {
        stagingDomain: '.netsuitestaging.com',
        mountToApp: function mountToApp(application) {
            var element = jQuery('meta[name="robots"]');

            if (location.hostname.indexOf(this.stagingDomain) !== -1) {
                if (element.length) {
                    element.attr('content', 'noindex, nofollow');
                } else {
                    jQuery('head').append('<meta name="robots" content="noindex, nofollow" />');
                }
            }
        }
    };
});
